export class UniqueSequenceGenerator {
    private currentValue: number;
    constructor() {
        this.currentValue = 0;
    }

    next() {
        this.currentValue++;
        return this.currentValue;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/utils/UniqueSequenceGenerator/UniqueSequenceGenerator.ts